export default "__VITE_ASSET__1815645f__"